import { locationOf } from "../utils/locationOf";
import { QIndexPair } from "./QIndexPair";
import { binary_search_iterative } from "../utils/binary_search_iterative";

export class QIndex {
  constructor() {
    this.fClass = null;
    this.fFieldDef = null;
    this.fPersistOnly = null;
    this.fPopBlanks = null;
    this.fBlankCounter = null;
    this.fForceLower = false;
    this.fIndex = null;
  }

  InitIndex(theClass, fieldDef, persistOnly, populateBlanks) {
    this.fClass = theClass;
    this.fFieldDef = fieldDef;
    this.fPersistOnly = persistOnly;
    this.fIndex = [];
    this.fPopBlanks = populateBlanks;
    this.fBlankCounter = 1;

    this.BuildIndex();
  }

  SetForceLower(forceLower) {
    return (this.fForceLower = forceLower);
  }

  GetIndexLength() {
    return this.fIndex.length;
  }

  AddToIndex(obj, value) {
    value = String(value);
    var p = new QIndexPair();

    if (this.fForceLower && value != null && typeof value == "string") value = value.toLowerCase();

    p.InitPair(obj, value);

    //var l = locationOf(value, this.fIndex);
    if (this.fIndex.length == 0) this.fIndex.push(p);
    else {
      //    gOverflowCounter = 0;
      var l = locationOf(value, this.fIndex);
      //findLocationFor(this.fIndex, value);
      this.fIndex.splice(l + 1, 0, p);
    }
  }

  BuildIndex() {
    var n = this.fClass.GetObjectCount();
    var fieldDef = this.fFieldDef;
    var pOnly = this.fPersistOnly;
    var pairs = [];
    for (var i = 0; i < n; i++) {
      var o = this.fClass.GetIndexObject(i);
      var isP = o.IsPersistent();
      if (pOnly && !isP) continue;

      var ov = o.GetFieldValue(fieldDef);

      if (this.fPopBlanks && (ov == null || ov.length == 0)) {
        ov = "Blank" + (this.fBlankCounter++).toString();
        o.SetFieldValue(fieldDef, ov);
      }

      var p = new QIndexPair();
      ov = String(ov);
      if (this.fForceLower && ov != null && typeof ov == "string") ov = ov.toLowerCase();
      p.InitPair(o, ov);
      pairs.push(p);
    }
    // Sort once: O(n log n) instead of n × O(n) splice insertions
    pairs.sort(function (a, b) {
      if (a.fValue < b.fValue) return -1;
      if (a.fValue > b.fValue) return 1;
      return 0;
    });
    this.fIndex = this.fIndex.concat(pairs);
  }

  FindObject(fieldValue) {
    var o = null;
    fieldValue = String(fieldValue);
    var p = binary_search_iterative(this.fIndex, fieldValue);
    if (p != null) o = this.fIndex[p].fObj;

    return o;
  }
}
